import CryptoJS from "crypto-js";

// Decrypt Data Object
function decryptData(encryptedToken, secretKey, formatConfig) {
  return JSON.parse(CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(encryptedToken, secretKey, formatConfig)));
}

// Encrypt Data Object
function encryptData(data, secretKey, formatConfig) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey, formatConfig).toString();
}

export default {
  decryptData,
  encryptData,
};
